import { TROK0 } from "./TROK0";
import town_sketch from "url:../../assets/town-sketch.png";
import tree from "url:../../assets/trok/trok-tree.png";
import town_art from "url:../../assets/toart.png";
import { useNavigate } from "react-router";

export function TROKW () {
    const nav = useNavigate();

    return <div className='trok-main-width v-box gap-32'>
        <div className='trok-main gap-16'>
            <img src={town_sketch} width='100%' className="trok-box" />          
            <br/>
            <img src={town_art} width='100%' className="trok-box" />
            <br/>
            <div className="h-box gap-8">
                <img src={tree} className='trok-tree height-128' />
                <img src={tree} className='trok-tree height-128' onClick={() => {
                    nav("/vault");
                }} />
                <img src={tree} className='trok-tree height-128' />
            </div>
        </div>
    </div>
}